import { DownOutlined, GlobalOutlined } from '@ant-design/icons';
import { Grid, type MenuProps, Space } from 'antd';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCompanyContext } from '../../components/contexts/CompanyContextManager';
import { useRouter } from '../../components/contexts/RouterContextManager';
import Dropdown from '../../components/Dropdown';
import useTranslatedString from '../../utilities/useTranslatedString';
import { Action } from './ui';

export const ALL_COMPANIES = 'allCompanies';

const ConsoleCompanyMenu = () => {
    const { t } = useTranslation(['consoleLayout']);
    const router = useRouter();
    const { replace, companies, availableCompanies } = useCompanyContext();
    const translate = useTranslatedString();

    const screens = Grid.useBreakpoint();
    const selectedCompany = companies.length === 1 ? companies[0] : null;

    const onSelect = useCallback<MenuProps['onSelect']>(
        info => replace(info.key === ALL_COMPANIES ? null : info.key),
        [replace]
    );

    const allCompaniesLabel = screens.md ? t('consoleLayout:rightContent.allCompanies') : <GlobalOutlined />;
    const options = useMemo(
        () => [
            { label: t('consoleLayout:rightContent.allCompanies'), key: ALL_COMPANIES },
            ...availableCompanies.map(item => ({ label: translate(item.companyName), key: item.id })),
        ],
        [availableCompanies, t, translate]
    );
    // If admin with company router, selection company would be disabled
    if (router?.company) {
        return null;
    }

    if (options.length > 1) {
        return (
            <Dropdown
                disabled={options.length === 2}
                menu={{
                    items: options,
                    onSelect,
                    selectedKeys: selectedCompany ? [selectedCompany.id] : [ALL_COMPANIES],
                    selectable: true,
                }}
            >
                <Action>
                    <Space>
                        {selectedCompany ? translate(selectedCompany.companyName) : allCompaniesLabel}
                        {options.length > 2 && <DownOutlined style={{ fontSize: 9 }} />}
                    </Space>
                </Action>
            </Dropdown>
        );
    }

    return null;
};

export default ConsoleCompanyMenu;
